export default "__VITE_ASSET__Y9YOf3Dz__"